<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'SalonInfo'
}
</script>

<style lang="scss"></style>
